import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Table, Card } from "react-bootstrap";
import Select, { MultiValue } from "react-select";
import { UserService } from "../../../service/users.service";
import { turnoMap, User, CreateUserDto } from "../../../service/types/types";

export default function ViewTableUsers() {
  const [selectedUsers, setSelectedUsers] = useState<CreateUserDto[]>([]);
  const [usersOptions, setUsersOptions] = useState<{ value: string; label: string; }[]>([]);
  const [users, setUsers] = useState<User[]>([]);
  const [tableUsers, setTableUsers] = useState<CreateUserDto[]>([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const data = await UserService.findAll();
        setUsers(data);
        const options = data.map(user => ({
          value: user.rut,              
          label: `${user.name} (${user.turno})`,
        }));
        setUsersOptions(options);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    fetchUsers();
    
  }, []);

  // opciones para react-select
  const options = users.map((u) => ({
    value: u.rut,
    label: `${u.name} (${u.rut})`,
  }));

  const handleSelect = (options: MultiValue<{ value: string; label: string }>) => {
    const selectedUsers = users.filter((u) => options.some((opt) => opt.value === u.rut));
    const selectedUsersForm: CreateUserDto[] = selectedUsers.map((user) => ({
        rut: user.rut,
        name: user.name,
        phone: user.phone,
        email: user.email,
        direccion: user.direccion,
        cargo: user.cargo,
        jornada: user.jornada,
        contrato: user.contrato,
        prevision: user.prevision,
        turno: turnoMap[user.turno] ?? user.turno,
    }));
    setSelectedUsers(selectedUsersForm);
  };

  const handleAddToTable = () => {
    setTableUsers(selectedUsers);
  };

  return (
    <div className="w-100 min-vh-100 bg-light d-flex justify-content-center p-3">
      <Container fluid>
        <h2 className="mb-4 text-center">Seleccionar Usuarios</h2>

        {/* Selector con botón */}
        <Card className="shadow-sm mb-4 p-3">
          <Row className="align-items-center">
            <Col>
              <Select
                options={options}
                isMulti
                onChange={handleSelect}
                placeholder="Selecciona usuarios..."
                className="w-100"
              />
            </Col>
            <Col xs="auto">
              <Button variant="primary" onClick={handleAddToTable}>
                Añadir
              </Button>
            </Col>
          </Row>
        </Card>

        {/* Tabla de usuarios seleccionados */}
        {tableUsers.length > 0 && (
          <Card className="shadow-sm p-3">
            <h5 className="mb-3">Usuarios seleccionados</h5>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>RUT</th>
                  <th>Nombre</th>
                  <th>Teléfono</th>
                  <th>Email</th>
                  <th>Turno</th>
                </tr>
              </thead>
              <tbody>
                {tableUsers.map((u) => (
                  <tr key={u.rut}>
                    <td>{u.rut}</td>
                    <td>{u.name}</td>
                    <td>{u.phone}</td>
                    <td>{u.email || "-"}</td>
                    <td>{u.turno}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card>
        )}
      </Container>
    </div>
  );
}